import React, { Component } from 'react';
import { Button } from 'react-materialize';
import imgAtencao from '../../assets/images/atencao.png';

export default class NoData extends Component {
  render() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          border: '2px solid rgb(189, 32, 123)',
          padding: '10px',
          borderRadius: '10px',
        }}
      >
        <img src={imgAtencao} alt="sem informações" width={'96'} />
        <h6
          style={{
            fontSize: '1rem',
            fontWeight: '700',
            color: '#828282',
            textAlign: 'center',
            width: '100%',
          }}
        >{this.props.title === undefined ? 'SEM DADOS' : this.props.title}</h6>
        
        {this.props.buttonTitle !== undefined ||
        this.props.buttonClassName !== undefined ||
        this.props.buttonOnClick !== undefined ? (
          <Button
            className={
              this.props.buttonClassName !== undefined
                ? this.props.buttonClassName
                : ''
            }
            onClick={
              this.props.buttonOnClick !== undefined
                ? this.props.buttonOnClick
                : null
            }
          >
            {this.props.buttonTitle !== undefined ? this.props.buttonTitle : ''}
          </Button>
        ) : (
          <></>
        )}
      </div>
    );
  }
}
